/**
 * Per-agent configurations for the AE view agent side panel.
 * Each config defines the agent's identity, tool status messages,
 * and how to build attachments for that agent's context.
 */

const TOOL_MESSAGES = {
  get_component_registry: 'Loading component registry...',
  get_component_docs: 'Reviewing component docs...',
  search_blueprints: 'Searching for blueprints...',
  get_query_blueprint: 'Loading blueprint details...',
  execute_query_blueprint: 'Running blueprint query...',
  list_view_versions: 'Loading version history...',
  get_view_version: 'Fetching version content...',
  save_view_version: 'Saving new version...',
  propose_view_content: 'Preparing view content...',
  search_data_pipelines: 'Searching for data pipelines...',
  get_pipeline_schema: 'Inspecting pipeline fields...',
  execute_data_pipeline: 'Running data pipeline...'
}

export const AGENT_CONFIGS = {
  'ae-view-builder': {
    agentId: 'ae-view-builder',
    label: 'View Builder',
    placeholder: 'Describe the view you want to build...',
    toolMessages: {
      ...TOOL_MESSAGES,
      list_views: 'Browsing existing views...',
      get_view_edit_details: 'Inspecting view for reference...'
    },
    buildAttachments: () => []
  },
  'ae-view-editor': {
    agentId: 'ae-view-editor',
    label: 'View Editor',
    placeholder: 'Describe what you want to change...',
    toolMessages: {
      ...TOOL_MESSAGES,
      list_views: 'Browsing existing views...',
      get_view_edit_details: 'Loading current view details...'
    },
    buildAttachments: ({ viewId, content, tags } = {}) => [
      {
        name: 'currentView',
        content: {
          viewId: viewId || null,
          content: content || '',
          tags: Array.isArray(tags) ? tags : []
        }
      }
    ]
  }
}

export function getAgentConfig (agentId) {
  return AGENT_CONFIGS[agentId] || AGENT_CONFIGS['ae-view-builder']
}
